import { render, staticRenderFns } from "./loanInfo.vue?vue&type=template&id=058db894&scoped=true&"
import script from "./loanInfo.vue?vue&type=script&lang=js&"
export * from "./loanInfo.vue?vue&type=script&lang=js&"
import style0 from "./loanInfo.vue?vue&type=style&index=0&id=058db894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058db894",
  null
  
)

export default component.exports